import React from "react";
import TooltipContainer from "../TooltipContainer";
import SummonerSpellTooltip from "../tooltipInfoTypes/SummonerSpellTooltip";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const RoleQuestSummonerSpellWrapper = (props) => {
  const { getSummonerSpells, getSummonerSpellImg, useRiotSummoners } = getRiotAssetsContext();
  const { patch, language, style, disableTooltip, ssr, skip, webp, showIndicator, mobile = false } = props;
  const { data: summoners, loading: fetchingSummoners, error: errorSummoners } = useRiotSummoners({ patch, ssr, language, skip });
  const spellsJSON = summoners || getSummonerSpells({ language, patch });

  const roleQuestTeleportInfo = <SummonerSpellTooltip spellId={12} patch={patch} language={language} />;
  const roleQuestTeleportImgSrc = getSummonerSpellImg(12, { optionalData: spellsJSON, webp });

  return (
    <div className="relative inline-block">
      {props.children}
      {showIndicator && (
        <div className="absolute top-0 right-0 z-50 translate-x-1/2 -translate-y-1/2">
          <TooltipContainer tooltipInfo={roleQuestTeleportInfo} disableTooltip={disableTooltip}>
            <img
              className={mobile ? "w-[10px] h-[10px] rounded-sm" : "w-[14px] h-[14px] rounded-sm"}
              style={style}
              src={roleQuestTeleportImgSrc}
              alt={`Role Quest Summoner Spell ${name}`}
            />
          </TooltipContainer>
        </div>
      )}
    </div>
  );
};

export default React.memo(RoleQuestSummonerSpellWrapper);
